import { motion } from 'framer-motion';

const ProcessingProgress = ({ current, total }) => {
  const percentage = (current / total) * 100;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200"
    >
      <div className="flex justify-between items-center mb-2 text-xs">
        <span className="font-medium text-blue-700">
          Processing your booking...
        </span>
        <span className="font-semibold text-blue-600">
          {current}/{total}
        </span>
      </div>
      <div className="w-full bg-blue-200 rounded-full h-1.5 overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="bg-blue-600 h-1.5 rounded-full"
        />
      </div>
      <div className="text-xs text-blue-600 mt-1 text-center">
        {percentage.toFixed(0)}% Complete
      </div>
    </motion.div>
  );
};

export default ProcessingProgress;